import React from 'react';

interface ModalProps {
    onClose: () => void;
    children: React.ReactNode;
    maxWidth?: string;
}

/**
 * 공통 모달 오버레이 래퍼.
 * 배경 클릭 시 닫히고, 내부 클릭은 전파를 막음.
 */
const Modal: React.FC<ModalProps> = ({ onClose, children, maxWidth = 'max-w-lg' }) => {
    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4"
            onClick={onClose}
            aria-modal="true"
            role="dialog"
        >
            <div
                className={`bg-rose-50/80 backdrop-blur-lg border border-white/30 rounded-2xl shadow-lg w-full ${maxWidth} max-h-[90vh] overflow-y-auto`}
                onClick={(e) => e.stopPropagation()}
            >
                {children}
            </div>
        </div>
    );
};

export default Modal;
